import _ from 'lodash';

class WixBaseEvent {
    constructor(event) {
        this.type = _.get(event, 'action') || _.get(event, 'type');
        this.context = _.get(event, 'context');
    }
}

export default WixBaseEvent;
